// Library
import { defineStyleConfig } from '@chakra-ui/react';

export const Button = defineStyleConfig({
  variants: {
    light: {
      bg: 'transparent',
      p: 2,
      color: 'tealish.100',
      h: 'fit-content',
      w: 'fit-content',
      minW: 'fit-content',
      _hover: {
        bg: 'none',
        color: 'tealish.60',
      },
      _active: {
        bg: 'none',
        color: 'tealish.300',
      },
    },
    baseLight: {
      bg: 'transparent',
      _hover: {
        bg: 'close.hover',
        '.chakra-icon': {
          color: 'base',
        },
      },
      _active: {
        bg: 'close.active',
        '.chakra-icon': {
          color: 'base',
        },
      },
      _focusVisible: {
        bg: 'close.hover',
        '.chakra-icon': {
          color: 'base',
        },
      },
    },
    submit: {
      w: 36,
      bg: 'submitScheme.500',
      color: 'white',
      _hover: {
        bg: 'submitScheme.600',
        _disabled: {
          bg: 'submitScheme.600',
        },
      },
      _active: {
        bg: 'submitScheme.700',
      },
      _focusVisible: {
        bg: 'submitScheme.600',
      },
    },
    onlyIcon: {
      bg: 'transparent',
    },
    pill: {
      h: 7.5,
      fontSize: 's',
      fontWeight: 'normal',
      bg: 'white',
      color: 'grey.800',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: 'grey.20',
      borderRadius: 'full',
      _hover: {
        bg: 'backgrounds.default',
        borderColor: 'blueNavy',
      },
      _active: {
        borderWidth: '2px',
        borderColor: 'base',
        fontWeight: 'medium',
        bg: 'white',
      },
    },
    smallPill: {
      h: 6,
      fontSize: 's',
      fontWeight: 'normal',
      bg: 'white',
      color: 'tealishBlue',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: 'transparent',
      borderRadius: 'full',
      px: 2,
      _hover: {
        bg: 'backgrounds.default',
        borderColor: 'blueNavy',
      },
      _active: {
        bg: 'backgrounds.default',
        borderColor: 'blueNavy',
      },
    },
    dropdown: {
      w: 'full',
      display: 'flex',
      boxShadow: 'none',
      justifyContent: 'space-between',
      fontWeight: 'normal',
      fontSize: 'm',
      border: 'greyCheck',
      borderRadius: 'md',
      _hover: { borderColor: 'celestialBlue', _disabled: { border: 'greyCheck' } },
      _active: {
        shadow: 'outline',
      },
      _focusVisible: {
        shadow: 'outline',
      },
    },
    group: {
      color: 'text.dark',
      fontSize: 's',
      fontWeight: 'normal',
      h: 8,
      colorScheme: 'controlScheme',
      _disabled: {
        bg: 'transparent',
        border: 'greyCheck',
      },
    },
    tab: {
      h: 4,
      paddingInlineStart: 0,
      paddingInlineEnd: 0,
      fontSize: 's',
      fontWeight: 'normal',
      color: 'grey.800',
      borderRadius: 'none',
      _hover: {
        color: 'base',
      },
      _selected: {
        fontWeight: 'medium',
      },
    },
    wrapper: {
      bg: 'transparent',
      border: 'none',
      h: 'auto',
      w: 'auto',
      minW: 'unset',
      p: 0,
      _hover: {
        bg: 'transparent',
      },
    },
    warning: {
      w: 36,
      width: 'fit-content',
      color: 'white',
      bg: 'warning.50',
      _hover: {
        bg: 'warning.500',
        _disabled: {
          bg: 'warning.50',
        },
      },
      _active: {
        bg: 'warning.900',
      },
    },
    outline: {
      border: '1px solid',
      borderColor: 'tealishBlue',
      fontSize: 'md',
      background: 'white',
      fontWeight: 'medium',
      _hover: {
        background: 'gray.100',
      },
      _active: {
        background: 'gray.200',
      },
    },
  },
});
